/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/GiveStar.css";

import { Rating } from "react-simple-star-rating";

/////////////   Redux  //////////////
import { useSelector, useDispatch } from "react-redux";
import SecureStorage from "react-secure-storage";

export default function GiveStarTH(props) {
  const globalData = useSelector((state) => ({ ...state }));
  const detailReport = JSON.parse(sessionStorage.getItem("detailReport2"));

  const [lang, setLanguage] = useState(true);
  const [rating, setRating] = useState(0);

  useEffect(() => {
    setRating(detailReport["case"]["star"]);
  }, []);
  const handleRating = (rate) => {
    setRating(rate);
    // console.log(rate);
  };

  return (
    <div class="container-givestar">
      <div
        className={`container-bg-givestar ${
          detailReport["case"]["star"] != null ? "disable-div" : ""
        }`}>
        <p>ความเห็นของคุณมีความหมายสำหรับเรา!</p>
        <p style={{ marginTop: "-0.8rem" }}>
          เราแก้ไขปัญหานี้ดีแค่ไหน? (แตะที่ดาวเพื่อให้คะแนน)
        </p>
        <Rating
          onClick={handleRating}
          initialValue={rating}
          disabled="true"
          size={24}
        />
      </div>

      <div>
        <p className="main-txt">เราดีใจและขอขอบพระคุณเป็นอย่างยิ่ง</p>
        <p className="main-txt">
          ที่ท่านร่วมเป็นส่วนหนึ่งในการพัฒนาบ้านเมืองของเราให้น่าอยู่มากยิ่งขึ้น!
        </p>
      </div>
    </div>
  );
}
